import { render } from "./page-dap.vue?vue&type=template&id=2b92801c"
import script from "./page-dap.js?vue&type=script&lang=js"
export * from "./page-dap.js?vue&type=script&lang=js"

import "./page-dap.vue?vue&type=style&index=0&id=2b92801c&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__